// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeader_wrapper__3xvwx","content":"SubHeader_content__36NkG","btnBack":"SubHeader_btnBack__1YYa9","line":"SubHeader_line__12b5K"};